import ManageTenders from './ManageTenders';
import apiService from './api';
import SearchTenders from './SearchTenders';
import React, { useState } from 'react';
import './App.css';
import Login from './Login';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [adminUser, setAdminUser] = useState('');
  const [currentView, setCurrentView] = useState('dashboard');

  const handleLogin = (username) => {
    setIsLoggedIn(true);
    setAdminUser(username);
  };

  const handleLogout = () => {
    apiService.logout();
    setIsLoggedIn(false);
    setAdminUser('');
    setCurrentView('dashboard');
  };

  // If not logged in, show login form
  if (!isLoggedIn) {
    return <Login onLogin={handleLogin} />;
  }

  // Main admin panel content
  return (
    <div className="App">
      <header className="admin-header">
        <div className="header-content">
          <div className="header-left">
            <h1>Indibids Admin Panel</h1>
            <p>Welcome to the tender management system</p>
          </div>
          <div className="header-right">
            <span className="user-info">Welcome, {adminUser}</span>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </header>

      <nav className="admin-nav">
        <button
          className={currentView === 'dashboard' ? 'nav-button active' : 'nav-button'}
          onClick={() => setCurrentView('dashboard')}
        >
          Dashboard
        </button>
        <button
          className={currentView === 'search' ? 'nav-button active' : 'nav-button'}
          onClick={() => setCurrentView('search')}
        >
          Search Tenders
        </button>
        <button
          className={currentView === 'manage' ? 'nav-button active' : 'nav-button'}
          onClick={() => setCurrentView('manage')}
        >
          Manage Tenders
        </button>
      </nav>

      <main className="admin-main">
        {currentView === 'dashboard' && (
          <>
            <div className="status-card">
              <h2>System Status</h2>
              <p>✅ Frontend: Running</p>
              <p>✅ Backend: Connected</p>
              <p>✅ Google Drive: Connected</p>
            </div>

            <div className="quick-actions">
              <h2>Quick Actions</h2>
              <button
                className="action-button"
                onClick={() => setCurrentView('search')}
              >
                Search Tenders
              </button>
              <button
                className="action-button"
                onClick={() => setCurrentView('manage')}
              >
                View Uploaded Tenders
              </button>
            </div>
          </>
        )}

        {currentView === 'search' && (
          <SearchTenders />
        )}


        {currentView === 'manage' && (
          <ManageTenders />
        )}
      </main>
    </div>
  );
}

export default App;
